import { environment } from '@core/environment';
import type { SplineElement, SplineElementAttribute } from '@elements/types';

export const getContainableSplineElements = async ({
  projectId,
  elementId,
  getAccessToken,
}: {
  projectId: string | undefined;
  elementId: string | undefined;
  getAccessToken: () => Promise<string>;
}) => {
  if (!projectId || !elementId) {
    return { data: [] };
  }

  try {
    const res = await fetch(
      `${environment.apiUrl}/projects/${projectId}/splineElements/${elementId}/containable`,
      {
        headers: { Authorization: `Bearer ${await getAccessToken()}` },
      },
    );

    if (!res.ok) {
      return { data: [] };
    }

    const json = (await res.json()) as SplineElement[];

    return { data: json ?? [] };
  } catch {
    return { data: [] };
  }
};

export const getSplineElementContainedAttributes = async ({
  projectId,
  elementId,
  getAccessToken,
}: {
  projectId: string | undefined;
  elementId: string | undefined;
  getAccessToken: () => Promise<string>;
}) => {
  if (!projectId || !elementId) {
    return { data: [] };
  }

  try {
    const res = await fetch(
      `${environment.apiUrl}/projects/${projectId}/splineElements/${elementId}/containedAttributes`,
      {
        headers: { Authorization: `Bearer ${await getAccessToken()}` },
      },
    );

    if (!res.ok) {
      return { data: [] };
    }

    const json = (await res.json()) as SplineElementAttribute[];

    return { data: json ?? [] };
  } catch {
    return { data: [] };
  }
};
